import { render, staticRenderFns } from "./NewsSection.vue?vue&type=template&id=7c70b8e4&scoped=true"
import script from "./NewsSection.vue?vue&type=script&lang=js"
export * from "./NewsSection.vue?vue&type=script&lang=js"
import style0 from "./NewsSection.vue?vue&type=style&index=0&id=7c70b8e4&prod&scoped=true&lang=css"
import style1 from "./NewsSection.vue?vue&type=style&index=1&id=7c70b8e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_729849d24245ac5da8661ad62b6d24d8/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c70b8e4",
  null
  
)

export default component.exports